import PaymentItemCard from "./PaymentItemCard";

const PaymentList = ({ items, onUpdate, onRemove }) => {
  if (items.length === 0) {
    return (
      <tbody>
        <tr>
          <td colSpan={4} className="px-4 py-10 text-center">
            <p className="text-sm text-body dark:text-bodydark2">
              Sin métodos de pago agregados
            </p>
            <p className="mt-1 text-xs text-body dark:text-bodydark2">
              Selecciona una forma de pago arriba para agregarla aquí
            </p>
          </td>
        </tr>
      </tbody>
    );
  }

  return (
    <tbody>
      {items.map((item) => (
        <PaymentItemCard
          key={item.id}
          item={item}
          onUpdate={onUpdate}
          onRemove={onRemove}
        />
      ))}
    </tbody>
  );
};

export default PaymentList;
